import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';



@Injectable({
    providedIn: 'root'
})
export class DisplayBehaviorService {
    private local = inject(LocalStorageService);

    private currentDisplayBehavior: BehaviorSubject<E_DisplayBehavior> = new BehaviorSubject<E_DisplayBehavior>(E_DisplayBehavior.Default);
    private currentDisplayFilterBehavior: BehaviorSubject<Map<string,string[]>> = new BehaviorSubject<Map<string,string[]>>(new Map<string,string[]>());

    constructor() {
        this.initializeDisplayBehavior();
    }

    private initializeDisplayBehavior() {
      const localValue = this.local.getItem("display-behavior");
      const localFilterValue = this.local.getItem("display-filter-behavior");
      const filterMap = localFilterValue
        ? new Map<string, string[]>(Object.entries(localFilterValue))
        : new Map<string, string[]>();        this.currentDisplayBehavior.next(localValue == E_DisplayBehavior.Demo ? E_DisplayBehavior.Demo : E_DisplayBehavior.Default);
      this.currentDisplayFilterBehavior.next(filterMap??{});
    }

    getDisplayBehavior(): Observable<E_DisplayBehavior> {
        return this.currentDisplayBehavior.asObservable();
    }

    setDisplayBehavior(mode: E_DisplayBehavior): void {
        this.local.setItem("display-behavior", mode);
        this.currentDisplayBehavior.next(mode);
    }

    getDisplayFilterBehavior(): Observable<Map<string,string[]>> {
        return this.currentDisplayFilterBehavior.asObservable();
    }

    setDisplayFilterBehavior(displayId: string, filter: string[]): void {
      // Obtenemos el valor actual del BehaviorSubject (que ya es un Map)
      const currentMap = this.currentDisplayFilterBehavior.value;

      // Actualizamos el Map
      currentMap.set(displayId, filter);

      // 1. Convertimos el Map a Objeto para el LocalStorage
      const objForStorage = Object.fromEntries(currentMap);
      this.local.setItem("display-filter-behavior", objForStorage);

      // 2. Emitimos el Map actualizado a los suscriptores
      this.currentDisplayFilterBehavior.next(new Map(currentMap));
    }

}


export enum E_DisplayBehavior {
    Default = 'default',
    Demo = 'demo',
}
